export default {
  labels: {
    signed_by: 'Semnat de {{name}} pe {{date}}',
    signed_by_no_date: 'Semnat de {{name}}',
  },
  buttons: {
    retry: 'Încearcă din nou',
  },
  errors: {
    load_failed: 'Contractul nu a putut fi încărcat. Verifică conexiunea și încearcă din nou.',
  },
};
